import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import GeoPosition from '../interfaces/geo-position';
import { HttpClient } from './http-client';

const OPEN_WEATHER_MAP = {
  units: 'metric',
  lang: 'la',
};

interface Cache {
  [url: string]: Observable<any>;
}

export class WeatherService extends HttpClient {
  protected cache: Cache = {};

  protected getCache<T>(
    url: string,
    params: { [key: string]: string | number | boolean } = {}
  ) {
    if (Object.keys(params).length) {
      const searchParams = new URLSearchParams();
      Object.keys(params).forEach(
        (key) => params[key] && searchParams.append(key, params[key].toString())
      );
      url = url.concat('?', searchParams.toString());
    }

    if (!this.cache[url]) {
      this.cache[url] = this.ajax(url, { method: 'get' }).pipe(
        map((response) => response?.response as T),
        shareReplay({ refCount: true, bufferSize: 1 })
      );
    }

    return this.cache[url];
  }

  getData({ lat, lon }: GeoPosition): any {
    return this.getCache<any>(
      `/api/weather/${lat}/${lon}/${OPEN_WEATHER_MAP.units}/${OPEN_WEATHER_MAP.lang}`
    );
  }
}
